import * as React from "react";
import type { SVGProps } from "react";
const SvgAlarm06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.856 18.912 3.168 21.6m17.664 0-2.688-2.688L3.3 3.9 1.8 5.4m20.4 0-3-3M9.6 4.666A8.448 8.448 0 0 1 20.15 15m-2.75 4.265A8.448 8.448 0 0 1 5.646 7.2"
    />
  </svg>
);
export default SvgAlarm06;
